import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import Link from "next/link";
import { ProfileIcon } from "../header/profileIcon";
import { LoginInfoModal } from "../loginInfoModal/loginInfoModal";
import { useTranslations } from "next-intl";
import pom from "@/utils/pom";
import { useNativeActions } from "@/utils/useNativeActions";
import { HybridLink } from "./hybridLink";
import { useAuth } from "@/app/providers/authProvider";

export const UtilityPanel = ({
  handleLoginModal,
  loginModalIsOpen,
  setLoginModalIsOpen,
  deleteSession,
  merchantColor,
  toCheckoutAfterLogin,
  merchant,
  isCustomerLoggedIn,
}: any) => {
  const t = useTranslations("UtilityPanel");
  const { isLoggedIn } = useAuth();
  const { isCmaApp, openCustomerProfile } = useNativeActions();

  return (
    <>
      {isLoggedIn ? (
        <Popover className="relative">
          <PopoverButton
            className="flex items-center gap-x-2 leading-6 hover:bg-gray-50 font-normal text-base focus-visible:outline-2 focus-visible:outline-offset-2"
            aria-label={t("openUserMenuLabel")}
            data-testid={pom.navigationBar.navigationBarUserUtilityPanel}
          >
            <ProfileIcon merchantColor={merchantColor} aria-hidden="true" />
          </PopoverButton>

          <PopoverPanel
            transition
            className="absolute -right-8 top-full z-20 mt-3 w-max overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <nav className="p-3" aria-label={t("navDescriptiveText")}>
              <div className="group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-gray-50">
                <div className="flex-auto">
                  <HybridLink
                    href={`/customer-profile`}
                    nativeAction={openCustomerProfile}
                    className="block text-gray-900 font-normal text-base leading-6"
                  >
                    {t("account")}
                    <span className="absolute inset-0" aria-hidden="true" />
                  </HybridLink>
                </div>
              </div>

              <div className="group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-gray-50">
                <div className="flex-auto">
                  <Link
                    href={
                      merchant.isService ? "/my-appointments" : "/my-orders"
                    }
                    className="block text-gray-900 font-normal text-base leading-6"
                  >
                    {t("myOrders")}
                    <span className="absolute inset-0" aria-hidden="true" />
                  </Link>
                </div>
              </div>

              {!isCmaApp && (
                <div className="group relative flex items-center gap-x-6 rounded-lg p-3 hover:bg-gray-50">
                  <div className="flex-auto">
                    <button
                      className="block w-full text-left text-gray-900 font-normal text-base leading-6"
                      onClick={() => deleteSession()}
                    >
                      {t("logOut")}
                      <span className="absolute inset-0" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              )}
            </nav>
          </PopoverPanel>
        </Popover>
      ) : (
        <div className="flex flex-col justify-center items-center">
          <button
            onClick={() => handleLoginModal(false)}
            aria-label={t("loginLabel")}
            className="focus-visible:outline-2"
          >
            <ProfileIcon merchantColor={merchantColor} aria-hidden="true" />
          </button>
        </div>
      )}

      <LoginInfoModal
        isOpen={loginModalIsOpen}
        onRequestClose={() => setLoginModalIsOpen(false)}
        merchantColor={merchantColor}
        toCheckoutAfterLogin={toCheckoutAfterLogin}
        merchant={merchant}
      />
    </>
  );
};
